import Icon from '~/src/common/components/Icon';
import TypeTag from '~/src/common/components/Recipe/TypeTag/TypeTag';
import { Tag } from '~/src/common/components/Tag/Tag';
import I18n from '~/src/common/services/I18n';
import { GetRecipeByIdOrSlug200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  className?: string;
  recipe: GetRecipeByIdOrSlug200;
}

export const RecipeNameAndTags = (props: Props) => (
  <S.Root className={props.className}>
    <S.Tags>
      {props.recipe.cookTypes.map(tag => (
        <Tag key={tag} bgColor="FLAG_PROMO" fgColor="NEUTRAL_DEFAULT">
          {tag}
        </Tag>
      ))}
      <TypeTag recipeType={props.recipe.recipeType} />
      <Tag>
        <S.DurationTagContainer>
          <Icon name="clock-normal" size={16} color="NEUTRAL_DEFAULT" />
          {I18n.t('recipe-screen.duration-time', {
            duration: props.recipe.cookingTime + props.recipe.preparationTime,
          })}
        </S.DurationTagContainer>
      </Tag>
    </S.Tags>
    <S.CatalogItemName>{props.recipe.name}</S.CatalogItemName>
  </S.Root>
);
